module.exports = __webpack_public_path__ + "static/logo-06821a349f3d9eb3c5dca15a2797e89b.svg";